import $ from 'jquery';

export function displayValidationSummary(container, errors) {
    $('.validation-summary-valid, .validation-summary-errors', container).each(function() {
        var list = $(this)
            .addClass('validation-summary-errors')
            .removeClass('validation-summary-valid')
            .children('ul:first')
            .html('');

        $.each(errors, (i, error) => {
            list.append($('<li></li>').html(error));
        });
    });
}

export function hideValidationSummary(container, filter = null, prefix = '') {
    // Set a default filter if not specified.
    if (filter == null)
        filter = () => true;

    // Hide all validation summaries.
    $(`${prefix}.validation-summary-errors`, container)
        .filter(filter)
        .removeClass('validation-summary-errors')
        .addClass('validation-summary-valid');

    // Hide all field validations.
    $(`${prefix}.field-validation-error`, container)
        .filter(filter)
        .removeClass('field-validation-error')
        .addClass('field-validation-valid');

    // Remove all "has-error" classes.
    $(`${prefix}.has-error`, container)
        .filter(filter)
        .removeClass('has-error');
}

export function hide(target, duration = 400) {
    $(target).hide(duration);
    dispatchEvent(target, 'hide');
}

export function scrollTo(target, behavior = 'smooth') {
    window.scroll({
        top: $(target).offset().top,
        behavior: behavior
    });
}

export function show(target, duration = 400) {
    $(target).show(duration).trigger('show');
    dispatchEvent(target, 'show');
}

export function toggle(target, duration = 400) {
    $(target).toggle(duration);
    dispatchEvent(target, 'toggle');
}

function dispatchEvent(target, name) {
    // Make sure the target exists. This is null sometimes when submitting a form.
    if (target === null)
        return;

    if (target instanceof NodeList)
        target.forEach(node => node.dispatchEvent(new Event(name)));
    else
        target.dispatchEvent(new Event(name));
}